import { createNamespacedHelpers } from 'vuex';
import { getPartyAttribuites } from '@/modules/lawsuit/helpers/party-attributes-utils';

const { mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  data() {
    return {
      activePartyTypes: [],
      key: null,
    };
  },
  computed: {
    partyAttributesResult() {
      return getPartyAttribuites(this.activePartyTypes, {
        caseTypeId: this.caseTypeId,
        legalPositionId: this.legalPositionId,
        partyTypeId: this.partyTypeId,
      });
    },
    partyTypesList() {
      return this.partyAttributesResult.partyTypesList;
    },
    partyRolesList() {
      return this.partyAttributesResult.partyRolesList;
    },
  },
  watch: {
    caseTypeId() {
      this.getPartyTypes();
    },
    legalPositionId() {
      this.getPartyTypes();
    },
  },
  methods: {
    ...mapActions(['getActivePartyAttributes']),
    async getPartyTypes() {
      if (this.caseTypeId == null || this.legalPositionId == null) return;

      const compinedKey = `${this.caseTypeId}|${this.legalPositionId}`;
      if (this.key === compinedKey) return;
      this.key = compinedKey;

      const data = await this.getActivePartyAttributes({
        caseTypeId: this.caseTypeId,
        casePartyRole: this.legalPositionId,
        partyTypeId: null,
        partyRoleId: null,
      });
      this.activePartyTypes = data || [];
    },
  },
  created() {
    this.getPartyTypes();
  },
};
